import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { services } from '../data/services';
import { EndNote } from '../components/EndNote';
import { SeoHead } from '../components/SeoHead';
export function About() {
  const [openNumber, setOpenNumber] = useState<string | null>(null);
  return <div data-id="element-76" data-mp="2ejrrvda6gd7h">
      <SeoHead title="About Breezy Experiential — Experiential Strategy, Design & Production" description="Breezy Experiential blends creative strategy, elevated design and seamless operations across experiential production, mobile tours, tradeshows, conferences, fabrication and logistics." data-id="element-77" data-mp="2eji13nhb620q" />

      <header className="mx-auto max-w-page px-6 pb-16 pt-14 md:px-10 md:pb-24 md:pt-24" data-id="element-78" data-mp="2s9v7vmigraoh">
        <h1 className="max-w-3xl font-display text-3xl font-medium uppercase leading-[1.1] md:text-5xl" data-id="element-79" data-mp="2x7mzeff74us5">
          A creative experiential production studio blending innovative
          strategy, elevated design and{' '}
          <span className="text-lilac" data-id="element-80" data-mp="1lrydlrdoi1sx">seamless operations</span>.
        </h1>
      </header>

      <section className="mx-auto max-w-page px-6 pb-20 md:px-10 md:pb-32" data-id="element-81" data-mp="1ujw7bgr7zka1">
        <div className="grid gap-8 md:grid-cols-12" data-id="element-82" data-mp="1pk9tb53ki006">
          <h2 className="md:col-span-3 text-[0.65rem] uppercase tracking-micro text-muted" data-id="element-83" data-mp="23i882blsvyg7">
            What we do
          </h2>

          <ul className="md:col-span-9 border-t border-line" data-id="element-84" data-mp="1yibzdz25riub">
            {services.map(service => {
            const isOpen = openNumber === service.number;
            return <li key={service.number} className="border-b border-line" data-id="element-85" data-mp="28iclfsrewd27">
                  <h3 data-id="element-86" data-mp="2m8puxzjybztn">
                    <button type="button" onClick={() => setOpenNumber(isOpen ? null : service.number)} aria-expanded={isOpen} aria-controls={`service-${service.number}`} className="group flex w-full items-center gap-5 py-5 text-left transition-colors hover:text-lilac" data-id="element-87" data-mp="2m7wlgqtlyw7t">
                      <span className="font-display text-lg uppercase leading-none md:text-2xl" data-id="element-88" data-mp="1ostiad81iyd2">
                        {service.title}
                      </span>
                      <span className="ml-auto shrink-0 text-muted transition-colors group-hover:text-lilac" data-id="element-89" data-mp="1xujcfqtb4bej">
                        {isOpen ? <MinusIcon size={16} data-id="element-90" data-mp="27l4e5n4a1w1o" /> : <PlusIcon size={16} data-id="element-91" data-mp="27n8lyg5arf78" />}
                      </span>
                    </button>
                  </h3>

                  {isOpen && <div id={`service-${service.number}`} className="pb-7" data-id="element-92" data-mp="2gmlsp121dpo9">
                      <p className="max-w-2xl leading-relaxed text-muted" data-id="element-93" data-mp="2ljm1hjq9t6j2">
                        {service.description}
                      </p>
                      <ul className="mt-5 grid gap-x-10 gap-y-1.5 sm:grid-cols-2" data-id="element-94" data-mp="r6w6eyo61ra3">
                        {service.capabilities.map(capability => <li key={capability} className="text-sm text-cream/80" data-id="element-95" data-mp="jo50on4nj92z">
                            {capability}
                          </li>)}
                      </ul>
                    </div>}
                </li>;
          })}
          </ul>
        </div>
      </section>

      <EndNote data-id="element-96" data-mp="12k4wya4nwysd" />
    </div>;
}